export const Constants = {
  setupTitle: 'Configure o seu autenticador',
  setupIntro:
    'O seu perfil exige autenticação por aplicativo autenticador para entrar ' +
    'no sistema. Configure agora para concluir o acesso.',
  scanInstruction:
    'Escaneie o código QR com seu aplicativo (ex: Google Authenticator, ' +
    'Microsoft Authenticator, Authy)',
  howToScan: 'Como escanear',
  scanStep1: '1. Abra o seu aplicativo autenticador',
  scanStep2: '2. Toque em "+" ou "Adicionar conta"',
  scanStep3: '3. Selecione "Escanear o código QR"',
  scanStep4: '4. Aponte a câmera para o QR code acima',
  manualKey: 'Ou insira manualmente a chave secreta:',
  copied: 'copiado!',
  newQrCode: 'gerar novo QR',
  totpTitle: 'Verificação em duas etapas',
  totpInstruction: 'Digite o código do seu aplicativo autenticador',
  otpTitle: 'Verificação em duas etapas',
  otpInstruction: 'Enviamos um código para o seu e-mail e telefone',
  codeHint: 'Insira o código de 6 dígitos',
  newCodeIn: 'Um novo código poderá ser solicitado em:',
  seconds: 'segundos',
  requestNewCode: 'solicitar novo código',
  validate: 'validar',
  verify: 'verificar',
  cancel: 'cancelar',
  genericError: 'Algo deu errado, tente novamente.',
  expiredSession: 'Sua sessão expirou, entre novamente.',
  /** 401 body the API answers when the pending token is no longer accepted. */
  unauthenticated: 'Usuário não autenticado',
  otpResendCooldown: 60,
  codeLength: 6,
};
